import { FlamegraphNode, getTraceSpanCategoryFromFlamegraphNode } from '../domain/Trace'
import { SummaryLine } from './summary'

export const summarizeFlamegraph = (rootNode: FlamegraphNode): SummaryLine[] => {
    const groups = groupFlamegraphNodes(rootNode)
    const lines = groups.map(aggregateFlamegraphNodeGroup)
    const maxWallTime = rootNode.values.wt

    lines.forEach(line => {
        line.wallTimePercentage = maxWallTime > 0 ? line.wallTime / maxWallTime : 0
    })

    return lines
}

const groupFlamegraphNodes = (root: FlamegraphNode): FlamegraphNode[][] => {
    return Array.from(groupSubgraphNodeNames(root).values())
}

const groupSubgraphNodeNames = (graph: FlamegraphNode): Map<string, FlamegraphNode[]> => {
    const groups = new Map<string, FlamegraphNode[]>()
    groups.set(graph.name, [graph])

    for (const child of graph.children) {
        const childGroups = groupSubgraphNodeNames(child)
        childGroups.forEach((value, key) => {
            if (groups.has(key)) {
                groups.set(key, [...(groups.get(key) ?? []), ...value])
            } else {
                groups.set(key, value)
            }
        })
    }

    return groups
}

const aggregateFlamegraphNodeGroup = (group: FlamegraphNode[]): SummaryLine => {
    const firstNode = group[0]

    const callCount = group.reduce((value, node) => value + node.stats.ct, 0)
    const wallTime = group.reduce((value, node) => value + node.values.wt, 0)

    return {
        callCount,
        wallTime,
        wallTimePercentage: 0,
        exclusiveWallTime: 0,
        exclusiveWallTimePercentage: 0,
        id: firstNode.id,
        name: firstNode.title,
        category: getTraceSpanCategoryFromFlamegraphNode(firstNode),
        hasDetails: true,
    }
}
